module.exports = __webpack_public_path__ + "static/media/Amsterdam.3fe17556.png";